function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.02 12C21.02 16.95 16.98 20.97 12 20.97 7.02 20.97 2.98 16.95 2.98 12 2.98 7.05 7.02 3.03 12 3.03c4.98.0 9.02 4.02 9.02 8.97z",
  id: "cldxjqjEW"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 12C0 18.63 5.37 24 12 24 18.63 24 24 18.63 24 12 24 5.37 18.63.0 12 0 5.37.0.0 5.37.0 12zM17.88 15.97C17.69 16.16 16.16 17.69 15.97 17.88 15.74 18.11 15.37 18.11 15.15 17.88 14.94 17.67 13.89 16.61 12 14.71 10.11 16.61 9.06 17.67 8.85 17.88 8.62 18.11 8.25 18.11 8.03 17.88 7.84 17.69 6.31 16.16 6.12 15.97 5.89 15.74 5.89 15.37 6.12 15.15 6.33 14.94 7.39 13.89 9.29 12 7.39 10.11 6.33 9.06 6.12 8.85 5.89 8.62 5.89 8.25 6.12 8.03 6.31 7.84 7.84 6.3 8.03 6.11 8.26 5.88 8.63 5.88 8.85 6.11 9.06 6.32 10.11 7.38 12 9.29 13.89 7.39 14.94 6.33 15.15 6.12 15.38 5.89 15.75 5.89 15.97 6.12 16.16 6.31 17.7 7.84 17.89 8.03 18.12 8.26 18.12 8.63 17.89 8.85 17.68 9.06 16.62 10.11 14.71 12L17.88 15.15C18.04 15.55 18.04 15.82 17.88 15.97z",
  id: "d4ljSBhAH"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cldxjqjEW",
  opacity: 1,
  fill: "#fff",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d4ljSBhAH",
  opacity: 1,
  fill: "#000",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d4ljSBhAH",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000",
  strokeWidth: 1,
  strokeOpacity: 0
})))));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.82da0c61.svg";
export { ForwardRef as ReactComponent };